module.exports = __webpack_public_path__ + "fonts/fa-solid-900.32267f3.ttf";